<template>
  <div class="container">
    <div class="tit">{{ $t('common').Activecenter }}</div>
    <div class="info">
      <!-- 邀请分佣 -->
      <div class="item" v-if="systemSetting.isCommission" @click="$router.push({ name: 'InviteReward' })">
        <svg-icon class-name="svgs" icon-class="share" />
        <div class="right">
          <div class="title"> {{ $t('activity.inviteTxt', { amount: systemSetting.commission1 }) }}</div>
          <div class="lable"> <span>{{ $t('activity').invitebtn }}</span></div>
        </div>
      </div>
      <!-- 充值分佣 -->
      <div class="item" v-if="systemSetting.isRechargeReward" @click="$router.push({ name: 'RechargeReward' })">
        <svg-icon class-name="svgs" icon-class="recharge_currency" />
        <div class="right">
          <div class="title">{{ $t('activity.rechargeTxt', { amount: systemSetting.rechargeReward1 }) }}</div>
          <div class="lable"> <span>{{ $t('activity').rechargebtn }}</span></div>
        </div>
      </div>
      <!-- 实名认证 -->
      <div class="item" v-if="systemSetting.isAuthReward" @click="$router.push({ name: 'AuthReward' })">
        <svg-icon class-name="svgs" icon-class="auth" />
        <div class="right">
          <div class="title">{{ $t('activity.authTxt', { amount: systemSetting.authReward }) }}</div>
          <div class="lable"> <span>{{ $t('activity').authbtn }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemApi from '@/api/system'

export default {
  data() {
    return {
      systemSetting: {}
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    this.getConfig()
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.systemSetting = res.systemSetting
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  margin-bottom: -60px;
  width: 100%;
  background: var(--background_color);

  .tit {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
  }

  .info {
    margin: 50px auto;
    max-width: 780px;

    .item {
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      padding: 40px;
      border: 1px solid var(--info_color);
      border-radius: 15px;
      &:hover{
        background: var(--info_color);
      }

      .svgs {
        width: 70px;
        height: 70px;
        color: var(--text_color);
      }

      .right {
        width: calc(100% - 50px);
        margin-left: 50px;

        .title {
          font-size: 25px;
          font-weight: bold;
          line-height: 1.7;
          color: var(--text_color);
        }

        .lable {
          margin-top: 20px;

          span {
            font-size: 16px;
            color: rgba(2, 156, 92, 1);
            padding: 2px 5px;
            border: 1px solid rgba(2, 156, 92, 0.3);
            border-radius: 7px;
          }

        }
      }
    }
  }
}
</style>
